import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HOST } from "Constant/Constant";

export const optionsStoreApi = createApi({
  reducerPath: "optionsStoreApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOST,
  }),

  endpoints: (builder) => ({
    getSiteIdOptions: builder.mutation({
      query: () =>
      {
        return {
          url: `/get-available-sites`,
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
    }),
  }),
});

export const { useGetSiteIdOptionsMutation } = optionsStoreApi;
